// import { useState } from 'react';
import NoData from '../../../../../../components/NoData';
// import useThemeContext from '../../../../../../contexts/theme';
import { Card } from './styles';

interface SavedPurchasesCardI {
  saved: number;
}

export default function SavedPurchasesCard({
  saved,
}: SavedPurchasesCardI) {
  // const { selectedTheme } = useThemeContext();
  // const [labelBeingShow, setLabelBeingShow] = useState({ description: '', value: '' });

  return (
    <Card>
      <div className="card-title">
        <div>Compras Economizadas({saved})</div>
      </div>

      {/* {(!!saved) && (
        <>
          <OpacityAnimation>
            <div className="card-main-graph">
              <VictoryPie
                data={[
                  { x: 'Compras economizadas', y: saved },
                  // { x: 'Gestão Saldos', y: balanceManagement }
                ]}
                animate={{
                  duration: 500
                }}
                colorScale="qualitative"
                height={335}
                labelPlacement="vertical"
                labelRadius={0.1}
                labelPosition="endAngle"
                style={{
                  labels: { fontSize: 0, fill: selectedTheme === 'dark' ? '#fff' : '#000' }
                }}
                padding={{ top: 0, bottom: 10 }}
                innerRadius={110}
                padAngle={1}
                events={[{
                  target: 'data',
                  eventHandlers: {
                    onMouseOver: () => {
                      return [
                        {
                          target: 'data',
                          mutation: ({ style, data, index }) => {
                            setLabelBeingShow({ description: data[index].x, value: data[index].y?.toFixed(2) });
                            return { style: Object.assign({}, style, { opacity: '0.8', cursor: 'help' }) };
                          }
                        }
                      ];
                    },
                    onMouseOut: () => {
                      return [
                        {
                          target: 'data',
                          mutation: () => {
                            setLabelBeingShow({ description: '', value: '' });
                            return null;
                          }
                        }
                      ];
                    }
                  }
                }]}
              />
              <label>
                <span>{labelBeingShow.value ? labelBeingShow.value : ''}</span>
                <span>{labelBeingShow.description}</span>
              </label>
            </div>
          </OpacityAnimation>
        </>
      )} */}

      {!!saved && (
        <div className="card-main" style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-around',
          alignItems: 'center',
          height: '100%',
        }}>
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}>
            <div style={{fontSize: '80px'}}>
              {saved}
            </div>
            <small>
              Compras economizados por ano
            </small>
          </div>
        </div>
      )}

      {(!saved) && (
        <NoData
          icon="emptyBox"
          label={(
            <>
              Não há dados de compras economizadas para o período selecionado
            </>
          )}
        />
      )}
    </Card>
  );
}
